import React, { useState, useEffect } from 'react';

const Numberofdata = () => {
  const data = [
    { count: 80, color: 'text-black', label: 'Customers' },
    { count: 10, color: 'text-black', label: 'Service Area' },
    { count: 30, color: 'text-black', label: 'Experts Worker' },
    { count: 100, color: 'text-black ', label: 'Project Completed' },
  ];
  return (
    <main className="py-6 px-2 md:px-12 space-y-8 bg-orange-50 w-full">
      <div className="flex flex-col w-full mx-auto space-y-6">
        <section className="flex flex-col mx-auto bg-gray-100 rounded-lg p-6 shadow-md space-y-6 w-full">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 w-full min-w-0 ">
            {data.map((item, index) => (
              <Counter
                key={index}
                maxCount={item.count}
                color={item.color}
                label={item.label}
              />
            ))}
          </div>
        </section>
      </div>
    </main>
  );
};

const Counter = ({ maxCount, color, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prevCount => {
        if (prevCount < maxCount) {
          return prevCount + 1;
        } else {
          clearInterval(interval);
          return prevCount;
        }
      });
    }, 100); // Change the delay (in ms) to adjust the speed of the count

    return () => clearInterval(interval);
  }, [maxCount]);

  return (
    <div className="flex flex-col px-6 py-2 bg-white shadow rounded-lg overflow-hidden">
      <div className="flex flex-col items-center space-y-2">
        <div
          className={`text-4xl font-bold tracking-tight leading-none ${color}`}
        >
          {count}+
        </div>
        <div
          className={`text-sm md:text-lg font-medium ${color.replace(
            '500',
            '600',
          )}`}
        >
          {label}
        </div>
      </div>
    </div>
  );
};

export default Numberofdata;
